// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: black;
  margin: 0;
}

@font-face {
  font-family: "Allura";
  src: url("assets/Allura-Regular.ttf") format("truetype");
}`, "",{"version":3,"sources":["webpack://./src/main.sass"],"names":[],"mappings":"AAAA;EACC,uBAAA;EACA,SAAA;AACD;;AACA;EACC,qBAAA;EACA,wDAAA;AAED","sourcesContent":["body\n\tbackground-color: black\n\tmargin: 0\n\n@font-face\n\tfont-family: \"Allura\"\n\tsrc: url(\"assets/Allura-Regular.ttf\") format(\"truetype\")\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
